import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CCard, CCardBody, CCardHeader, CSpinner } from '@coreui/react';
import { Chart } from 'react-google-charts';

const ChartCard = ({ title, data, chartType, options }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    if (Array.isArray(data) && data.length > 1) {
      setIsEmpty(false);
    }
    else {
      setIsEmpty(true);
    }
  }, [data]);
  
  return (
    <CCard className="mb-4 chart-card">
      <CCardHeader className="d-flex justify-content-between align-items-center">
        <h4>{title}</h4>
      </CCardHeader>
      <CCardBody className="chart-container">
        {(isEmpty && !isLoading) ? (
          <div className="text-center text-muted" style={{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            No Data
          </div>
        ) : (
          <Chart
            chartType={chartType}
            data={data}
            options={options}
            width="100%"
            height="300px"
            onLoad={() => setIsLoading(false)}
            loadingHeight="300px"
            chartWrapperParams={{ view: { columns: null } }}
            chartLanguage="en"
          />
        )}
      </CCardBody>
    </CCard>
  );
};

ChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  chartType: PropTypes.string.isRequired,
  options: PropTypes.object,
};

export default ChartCard;